"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SectionsFormattingChangedModelChange = void 0;
var enums_1 = require("../enums");
var SectionsFormattingChangedModelChange = (function () {
    function SectionsFormattingChangedModelChange(startSectionIndex, endSectionIndex, property, newState) {
        this.startSectionIndex = startSectionIndex;
        this.endSectionIndex = endSectionIndex;
        this.property = property;
        this.newState = newState;
        this.type = enums_1.ModelChangeType.SectionFormattingChanged;
    }
    return SectionsFormattingChangedModelChange;
}());
exports.SectionsFormattingChangedModelChange = SectionsFormattingChangedModelChange;
